<template>
  <div>
    <b-modal
      :title="$t('modal.product_sheets.title_edit',  { product_sheet_name: selectedObject.name })"
      :id="modalId"
      :ok-title="$t('modal.product_sheets.ok_button')"
      :cancel-title="$t('modal.general.cancel_button')"
      @show="resetForm"
      @ok="verifyForm">
      <b-form @submit.prevent="verifyForm">

        <!--SHEET NAME-->
        <b-form-group
          id="name-group"
          :label="$t('form.product_sheets.name')"
          :invalid-feedback="invalidName"
          :state="stateName"
          label-for="name"
        >
          <b-form-input
            id="name"
            v-model="selectedObject.name"
            :state="stateNameInput"
            :placeholder="$t('form.product_sheets.name')"
          ></b-form-input>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'

  export default {
    name: 'EditProductSheetModal',

    data () {
      return {
        loading: false,
      }
    },

    props: {
      modalId: {
        type: String,
        required: true
      },
      selectedObject: {
        type: Object,
        required: true
      }
    },

    validations: {
      selectedObject: {
        name: {
          required
        }
      }
    },

    computed: {

      payloads () {
        return {
          name: this.selectedObject.name,
        }
      },

      // VALIDATIONS

      stateNameInput () {
        return this.$v.selectedObject.name.$error ? false : null
      },
      stateName () {
        return (!this.$v.selectedObject.name.$error)
      },
      invalidName () {
        if (this.$v.selectedObject.name.$error) {
          if (!this.$v.selectedObject.name.required)
            return this.$t('validation.required', { field: this.$t('form.product_sheets.name') })
        }
        return null
      },
    },

    methods: {

      resetForm () {
        this.$v.$reset()
      },

      verifyForm (bvModalEvt) {
        bvModalEvt.preventDefault()
        this.$v.$touch()
        if (this.$v.$invalid)
          return
        this.editProductSheet()
      },
      editProductSheet () {
        if (this.loading)
          return
        this.loading = true
        this.loader = this.$loading.show(this.$_loaderOptions)
        this.$store.dispatch(this.$_actionTypes.UPDATE_USER_PRODUCT_SHEET, {
          payloads: this.payloads, id: this.selectedObject.id
        })
          .then(() => {
            this.$nextTick(() => {
              this.$bvModal.hide(this.modalId)
            })
            this.$notify({
              group: 'app',
              type: 'success',
              title: this.$t('notifications.title.success'),
              text: this.$t('notifications.text.product_sheets.success_product_sheet_edited')
            })
          })
          .catch((error) => {
            this.$_notifyError(error, this)
          })
          .finally(() => {
            this.loader.hide()
            this.loading = false
          })
      },
    }
  }
</script>

<style>

</style>
